export enum ConvertToWillCallAnalyticsMessages {
  capability = 'orders',
  willCallModalOpenEvent = 'modal open',
  willCallModalCloseEvent = 'modal close',
  modalName = 'convert to will call',
  submitWillCallRequestEvent = 'convert to will call',
}
